module.exports = __webpack_public_path__ + "media/ca_slide20_sweep_capsa.4a46977c.mp4";